export default {
  'Custom': 'Özel',
  'Original': 'Orijinal',
}